import React, { Fragment } from "react";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

const RecentSupporterItem = ({ supporter, deleteSupporter }) => {
  return (
    <Fragment>
      <div className="user-section-alt">
        <div className="setting-user-container">
          <div className="setting-friend-user-avi-container">
            <div
              className={`avi-color-border ${
                supporter && supporter.role === "innovator"
                  ? "green"
                  : supporter && supporter.role === "mentor"
                  ? "red"
                  : supporter && supporter.role === "employer"
                  ? "blue"
                  : ""
              }`}
            >
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${supporter.avatar}`}
                className="friend-user-avi"
                alt="avi"
              />
            </div>
          </div>
          <div className="friend-user-info">
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span
                    className={`${
                      supporter && supporter.role === "innovator"
                        ? "green"
                        : supporter && supporter.role === "mentor"
                        ? "red"
                        : supporter && supporter.role === "employer"
                        ? "blue"
                        : ""
                    } name-font`}
                  >
                    {supporter.channelid}
                  </span>
                </li>
                <li className="user-online-item">
                  {supporter.firstname} {supporter.lastname}
                </li>
                <li className="user-online-item">{supporter.jobtitle}</li>
                <li className="user-online-item">
                  {supporter && supporter.location.state},{" "}
                  {supporter && supporter.location.country}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="setting-friends-buttons-container">
          <div className="friend-button-container">
            <div
              className={`support-amount ${
                supporter && supporter.role === "innovator"
                  ? "green"
                  : supporter && supporter.role === "mentor"
                  ? "red"
                  : supporter && supporter.role === "employer"
                  ? "blue"
                  : ""
              } background-dark-black`}
            >
              {formatter.format(supporter.amount)}
            </div>
          </div>
          <div className="friend-button-container">
            <button
              onClick={() => deleteSupporter(supporter._id)}
              className={`setting-friend-button ${
                supporter && supporter.role === "innovator"
                  ? "background-green"
                  : supporter && supporter.role === "mentor"
                  ? "background-red"
                  : supporter && supporter.role === "employer"
                  ? "background-blue"
                  : ""
              }`}
            >
              <i className="fa-solid fa-times mx-5"></i>
              Delete
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default RecentSupporterItem;
